var _path, _path2, _line, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppearanceIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6495 2.94157V4.88312H12.973H13.2966V2.94157V1.00002H12.973H12.6495V2.94157Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47856 4.50572L4.26819 4.72147L5.63815 6.09682L7.01349 7.47217L7.24003 7.24564L7.47194 7.01372L6.11276 5.65454C5.36313 4.90490 4.73741 4.28996 4.72125 4.28996C4.70509 4.28996 4.59194 4.38694 4.47856 4.50572Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.4742,
    y1: 7.02447,
    x2: 21.2249,
    y2: 4.27378,
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1423 6.34467C10.6592 6.53887 9.28928 7.22385 8.21614 8.31854C7.28846 9.26238 6.71148 10.3517 6.41491 11.7055C6.28536 12.2932 6.28536 13.6416 6.41491 14.2404C7.00267 16.9532 8.99295 18.9434 11.7057 19.5312C12.3530 19.6661 13.5395 19.6554 14.2568 19.5043C17.4172 18.8354 19.6122 16.1712 19.6176 13.0000C19.6230 11.6031 19.2723 10.4489 18.4957 9.27316C17.1365 7.21307 14.5803 6.03193 12.1423 6.34467ZM12.6495 12.9785V18.9758L12.2773 18.9381C11.4304 18.8518 10.4004 18.4742 9.63459 17.9673C8.46422 17.1853 7.53654 15.8964 7.16454 14.5103C7.02961 14.0141 7.01883 13.89 7.01883 12.9733C7.01883 12.0672 7.02961 11.9271 7.15916 11.4525C7.61761 9.7752 8.75026 8.3783 10.2819 7.6125C10.9668 7.26744 11.8891 7.00295 12.4230 6.99218L12.6495 6.98679V12.9785ZM14.1326 7.06736C15.3676 7.33160 16.3276 7.84932 17.2122 8.73389C18.3826 9.90965 18.9703 11.3227 18.9703 12.9731C18.9703 15.8692 16.9318 18.3393 14.0895 18.8788C13.8576 18.9219 13.5826 18.9596 13.4802 18.9596H13.2968V12.9731V6.98654H13.5287C13.6526 6.98654 13.9223 7.02426 14.1326 7.06736Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.9731V13.2966H2.94155H4.8831V12.9731V12.6495H2.94155H1V12.9731Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.063 12.9731V13.2966H23.0315H25V12.9731V12.6495H23.0315H21.063V12.9731Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63816 19.8496L4.26282 21.2249L4.49474 21.4514L4.72127 21.6833L6.09661 20.3080L7.47196 18.9327L7.24004 18.7007L7.01351 18.4742L5.63816 19.8496Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7008 18.7061L18.4742 18.9327L19.8496 20.3080L21.2249 21.6833L21.4515 21.4514L21.6834 21.2249L20.3078 19.8496L18.9324 18.4742L18.7008 18.7061Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6495 23.0315V25H12.973H13.2966V23.0315V21.063H12.973H12.6495V23.0315Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppearanceIconWhite);
export default __webpack_public_path__ + "static/media/AppearanceIconWhite.6a0bd34ec116e84a8729927ee75127a6.svg";
export { ForwardRef as ReactComponent };